import { storyblokEditable } from "@storyblok/react"
import { type SbBlokYoutube } from "../types"

// Get the Youtube Video ID from given URL
const YOUTUBE_SPLIT_REGEX = /(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/
const YOUTUBE_ID_REGEX = /[^0-9a-z_\-]/i

function getVideoId(url: string) {
    const decodeUrl = url.replace(/(>|<)/i, "").split(YOUTUBE_SPLIT_REGEX)

    if (decodeUrl.length >= 3) {
        return decodeUrl[2].split(YOUTUBE_ID_REGEX)[0]
    }
}

interface DynamicYoutubeProps {
    blok: SbBlokYoutube
}

export function DynamicYoutube({ blok }: DynamicYoutubeProps) {
    const videoId = getVideoId(blok.videoUrl) || ""

    return (
        <iframe
            {...storyblokEditable(blok)}
            width="100%"
            height="480"
            title="YouTube video player"
            src={`https://www.youtube.com/embed/${videoId}`}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
        />
    )
}

export default DynamicYoutube
